import {fromJS} from 'immutable';
import MAP_STYLE from './map-style-bspaint-dashboard.json';


// For more information on data-driven styles, see https://www.mapbox.com/help/gl-dds-ref/
export const unclusteredLayer = {
    "id": "unclustered-point",
    "type": "circle",
    "source": "drawings",
    "filter": ["!", ["has", "point_count"]],
}


//

export const defaultMapStyle = fromJS(MAP_STYLE);



// WEBPACK FOOTER //
// ./src/components/pages/Hello/map-style.js